export default "__VITE_ASSET__D$bN7cfY__"